import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import copy from 'copy-to-clipboard';
import Layout from '../components/Layout';
import Textarea from '../components/Textarea';
import Button from '../components/Button';
import Card from '../components/Card';
import { calculateTextStats } from '../utils/textUtils';

const CharacterCounter: React.FC = () => {
  const [text, setText] = useState('');
  const [stats, setStats] = useState(calculateTextStats(''));
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    setStats(calculateTextStats(text));
  }, [text]);

  const handleCopy = () => {
    copy(text);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 2000);
  };

  const handleClear = () => {
    setText('');
  };

  return (
    <Layout showBackButton>
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-32"
        >
          <h1 className="text-4xl font-bold text-textPrimary mb-8">글자수 세기</h1>
          <p className="text-textSecondary">
            텍스트를 입력하면 자동으로 계산됩니다
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="mb-24"
        >
          <Textarea value={text} onChange={setText} minHeight="300px" />
        </motion.div>

        {text && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mb-24"
          >
            <Card>
              <h3 className="text-xl font-bold text-textPrimary mb-24 flex items-center gap-8">
                📊 실시간 통계
              </h3>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-24">
                <div>
                  <div className="text-textSecondary text-sm mb-4">
                    글자수 (공백 포함)
                  </div>
                  <div className="text-3xl font-bold text-primary">
                    {stats.charsWithSpaces.toLocaleString()}
                  </div>
                </div>
                <div>
                  <div className="text-textSecondary text-sm mb-4">
                    글자수 (공백 제외)
                  </div>
                  <div className="text-3xl font-bold text-primary">
                    {stats.charsWithoutSpaces.toLocaleString()}
                  </div>
                </div>
                <div>
                  <div className="text-textSecondary text-sm mb-4">단어 수</div>
                  <div className="text-3xl font-bold text-primary">
                    {stats.words.toLocaleString()}
                  </div>
                </div>
                <div>
                  <div className="text-textSecondary text-sm mb-4">문장 수</div>
                  <div className="text-3xl font-bold text-primary">
                    {stats.sentences.toLocaleString()}
                  </div>
                </div>
                <div>
                  <div className="text-textSecondary text-sm mb-4">문단 수</div>
                  <div className="text-3xl font-bold text-primary">
                    {stats.paragraphs.toLocaleString()}
                  </div>
                </div>
                <div>
                  <div className="text-textSecondary text-sm mb-4">읽는 시간</div>
                  <div className="text-3xl font-bold text-primary">
                    약 {stats.readingTime}분
                  </div>
                </div>
              </div>
            </Card>
          </motion.div>
        )}

        <div className="flex gap-12">
          <Button onClick={handleCopy} disabled={!text}>
            전체 복사
          </Button>
          <Button onClick={handleClear} variant="secondary" disabled={!text}>
            지우기
          </Button>
        </div>

        {showToast && (
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            className="fixed bottom-32 left-1/2 transform -translate-x-1/2 bg-textPrimary text-white px-24 py-12 rounded-medium shadow-lg"
          >
            ✓ 복사됨
          </motion.div>
        )}
      </div>
    </Layout>
  );
};

export default CharacterCounter;
